var React = require("react");
var $ = require('jquery');
var Reflux = require('reflux');
var slugify = require('../helpers/slugify');

// Actions
var JobActions = require('../actions/job_actions');

// Stores
var LanguageStore = require('../stores/language_store');
var JobStore = require('../stores/job_store');

// Job Area
module.exports = React.createClass({
	
	mixins: [
    	Reflux.listenTo(JobStore, 'onJobAction'), 
    ],
   
	onJobAction : function(event, data){
	    	
	    if(event === 'toggle_apply_popup'){
	    	if(this.state.show){
		    	this.setState({ show : false });
	    	} else {
	    		window.scrollTo(0, 0);
		    	this.setState({ show : true });
	    	}	
	    }
	},
	
	getInitialState : function(){
		return {
			show : false,
		}
	},
	
	closePopup : function(){
		JobActions.toggleApplyPopup();
	},
	
	// Render
  	render: function(){
  		
  		var style = {
  			display : (this.state.show) ? 'block' : 'none',
  			top : 0,
	  		left : 0
  		};
  		
  		if(typeof window != 'undefined'){
	  		style.top = (($(window).height() - 300) / 2);
	  		style.left = (($(window).width() - 350) / 2);
  		}
  		
  		var linkedinURL = 'http://jobs.searchsoftware.nl/linkedin?env='+this.props.env+'&job_id='+this.props.job_id;
  		var facebookURL = 'http://jobs.searchsoftware.nl/facebook?env='+this.props.env+'&job_id='+this.props.job_id;
  		
  		var manuallyFillUrl = '/'+this.props.env+'/apply/'+this.props.job_id+'/'+slugify(this.props.job.title);
  		
  		if(typeof this.props.env_info.custom_job_board_domain != 'undefined' && this.props.env_info.custom_job_board_domain != ''){
  			var custom_domain = this.props.env_info.custom_job_board_domain;
  			//var url_title = (job.url_title != '') ? job.url_title : slugify(job.title);
  			
  			
	  		manuallyFillUrl = 'http://'+custom_domain+'/apply/'+this.props.job_id+'/'+slugify(this.props.job.title);
	  		linkedinURL += '&d='+custom_domain;
	  		facebookURL += '&d='+custom_domain;
  		}
  		
  		var facebook_button = "";
   		var linkedin_button = "";
   		
   		if(LanguageStore.get('job_ad/link/connect_with_facebook') !== ''){
	   		facebook_button = (<li className="facebook">
	   			<a href={facebookURL}>
	   				<i className="fa fa-facebook-square icon"></i>
	   				<span className="text">{LanguageStore.get('job_ad/link/connect_with_facebook')}</span>
	   				<div className="clear"></div>
	   			</a>
	   		</li>);
   		}
   		
   		if(LanguageStore.get('job_ad/link/connect_with_linkedin') !== ''){
	   		linkedin_button = (<li className="linkedin">
   				<a href={linkedinURL}>
   					<i className="fa fa-linkedin-square icon"></i>
   					<span className="text">{LanguageStore.get('job_ad/link/connect_with_linkedin')}</span>
   					<div className="clear"></div>
   				</a>
  			</li>)
   		}
   		
   		return (
   			<div style={style} className="apply-popup">
   				
   				<h4>&nbsp;<i onClick={this.closePopup} className="fa fa-times-circle close-button"></i></h4>
   				
   				<ul className="list">
   					
   					{linkedin_button}
   					
   					{facebook_button}
   					
   					<li className="manual">
   						<a href={manuallyFillUrl}>
   							<i className="fa fa-edit icon"></i>
   							<span className="text">{LanguageStore.get('job_ad/link/fill_manually')}</span>
   							<div className="clear"></div>
   						</a>
   					</li>
   					
   				</ul>
   				
   			</div>
	  	);
	}
});
